import { useScrollPaddingTopHandler } from 'atoms/scrollPaddingTopAtom';
import { memo, useCallback, useRef } from 'react';
import { AnchorNavigation } from 'types/studio/studio';
import { CommonSectionProps } from '../types';
import { CardsNavigation } from './CardsNavigation';
import { CardsWithIconsNavigation } from './CardsWithIconsNavigation';
import { LinksNavigation } from './LinksNavigation';
import { useLinkSectionsIntersectionObserver } from './useLinkSectionsIntersectionObserver';

export const AnchorNavigationMarkup = memo(
  ({
    variant = 'links',
    addNumbers,
    anchors,
    bgColor,
    headline,
    theme,
    padding
  }: AnchorNavigation & CommonSectionProps) => {
    const cardsNavbarRef = useRef<HTMLDivElement | null>(null);
    const linksNavbarRef = useRef<HTMLDivElement | null>(null);

    const { height, top } = useScrollPaddingTopHandler(
      {
        type: 'navigation',
        // Don't assign to the scroll padding, just get the height and offset
        // for our navbar.
        disable: true
      },
      linksNavbarRef
    );

    const { activeLink, setActiveLinkWithScroll } = useLinkSectionsIntersectionObserver(
      anchors,
      height
    );
    const isActiveAnchor = useCallback((link: string) => link === activeLink, [activeLink]);

    return (
      <>
        {variant === 'cards' && (
          <CardsNavigation
            ref={cardsNavbarRef}
            addNumbers={addNumbers}
            variant={variant}
            anchors={anchors}
            bgColor={bgColor}
            isActiveAnchor={isActiveAnchor}
            setActiveLinkWithScroll={setActiveLinkWithScroll}
            padding={padding}
            theme={theme}
          />
        )}
        {variant === 'cardsWithIcons' && (
          <CardsWithIconsNavigation
            ref={cardsNavbarRef}
            headline={headline}
            anchors={anchors}
            bgColor={bgColor}
            setActiveLinkWithScroll={setActiveLinkWithScroll}
            padding={padding}
            theme={theme}
          />
        )}
        {variant !== 'cardsWithIcons' && (
          <LinksNavigation
            ref={linksNavbarRef}
            variant={variant}
            anchors={anchors}
            theme={theme}
            bgColor={bgColor}
            addNumbers={addNumbers}
            isActiveAnchor={isActiveAnchor}
            setActiveLinkWithScroll={setActiveLinkWithScroll}
            activeLink={activeLink}
            cardsNavbarRef={cardsNavbarRef}
            top={top}
          />
        )}
      </>
    );
  }
);

AnchorNavigationMarkup.displayName = 'AnchorNavigationMarkup';
